import React from 'react';
import { FaCheck } from 'react-icons/fa6';
import PromptActionButtons from '../../../promptLibrary/presentation/components/PromptActionButtons';
import './SelectablePromptCard.css';

const SelectablePromptCard = ({ prompt, isSelected = false, onToggle, onUpdate }) => {
  const handleCardClick = (e) => {
    e.stopPropagation();
    if (onToggle) {
      onToggle(prompt.id);
    }
  };

  return (
    <>
      <svg style={{ position: 'absolute', width: 0, height: 0 }}>
        <defs>
          <linearGradient id="favorite-gradient-selectable" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#F93AAC" />
            <stop offset="100%" stopColor="#FF613E" />
          </linearGradient>
        </defs>
      </svg>
      <div className="selectable-prompt-card-wrapper">
        <div 
          className={`selectable-prompt-card ${isSelected ? 'selected' : ''}`}
          onClick={handleCardClick}
        >
        {isSelected && (
          <div className="selection-badge">
            <FaCheck className="selection-check-icon" />
          </div>
        )}
        
        <div className="selectable-prompt-card-content">
          <h3 className="prompt-title">{prompt.title}</h3>
          
          <div className="prompt-description">
            <p>{prompt.description}</p>
          </div>
          
          <div className="prompt-actions">
            <PromptActionButtons 
              prompt={prompt} 
              stopPropagation={true}
              className=""
              buttonClassName="action-button"
              onUpdate={onUpdate}
              hideFavorite={true}
            />
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default SelectablePromptCard;

